import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function QuietPromise() {
  return <section className="py-20 px-4 bg-white border-y border-gray-100" data-id="element-97">
      <div className="max-w-3xl mx-auto text-center" data-id="element-98">
        <FadeIn data-id="element-99">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-800 mb-8" data-id="element-100">
            The Quiet Promise (Realistic, Not Magical)
          </h2>

          <p className="text-xl text-text-body mb-10" data-id="element-101">
            By the end of 30 nights, you should feel like:
          </p>

          <div className="grid gap-6" data-id="element-102">
            {['"I know what to do when something goes wrong."', '"I\'m not guessing anymore."', '"I\'m not dreading bedtime."'].map((quote, i) => <div key={i} className="bg-blue-50 p-6 rounded-lg" data-id="element-103">
                <p className="text-xl md:text-2xl font-serif italic text-navy-800 font-medium" data-id="element-104">
                  {quote}
                </p>
              </div>)}
          </div>

          <p className="mt-10 text-lg font-medium text-teal-700" data-id="element-105">
            And that's what makes long-term compliance possible.
          </p>
        </FadeIn>
      </div>
    </section>;
}